import { useEffect, useState, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { getProfilePosts, setFetchPostAttributes } from '../../features/posts/postSlice'
import '../../css/postItemSelectDropDown.css'
import { MdEmojiPeople } from 'react-icons/md';
import { FaPrayingHands, FaHands } from 'react-icons/fa';
import { IoMdRefreshCircle } from 'react-icons/io'; 
import useToggleDropdown from '../../hooks/useToggleDropdown' 
import { useParams } from 'react-router-dom';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { PostBtn,  PostSelectUl } from './postComponents.styled'; 

import { FaPersonPraying } from "react-icons/fa6";
import { BsPersonRaisedHand } from "react-icons/bs";
import { FaPersonWalking } from "react-icons/fa6";
import { useTranslation } from 'react-i18next'


function PostItemFilter( ) {
  const { t: translate } = useTranslation()
    const dispatch = useDispatch()
    const { churchName } = useParams()
    const ref1 = useRef(null)
    const [isDropped, setIsDropped] = useToggleDropdown(ref1)  
    const [isViewingAll, setIsViewingAll] = useState(true) 
    const [filter, setFilter] = useState(null)
    const { filterValue, myPostsPage } = useSelector((state) => state.posts)
    const { user } = useSelector((state) => state.auth)

    useEffect(() => {}, [isViewingAll, filter ])

    const handleClick = (value) => {

        if(value !== 'all' ){
            setIsViewingAll(false)
        }else{ 
            setIsViewingAll(true) 
        }
      
        dispatch(setFetchPostAttributes({
            type: 'filterValue',
            value: value
        })) 

        dispatch(getProfilePosts({
            churchName: churchName,
            currentPage: 1,
            filter: value
        }))

        console.log('postItemFilter')

    }

    return (
        <div style={{zIndex: '100'}}> 
                <PostBtn  
                    isFocused={isDropped}
                    ref={ref1}  
                    onClick={() => setIsDropped.toggle(ref1)}
                    > 
                        <FilterAltIcon style={{marginRight: '5px', fontSize: '18px'}} />
                        {
                            filterValue && filterValue !== 'all' ? 
                            (
                                <span>
                                    {
                                        translate(`web:general.${filterValue}`)
                                    }
                                </span> 
                            )
                            :
                            (
                                <span>
                                    {
                                        translate("web:general.filterPosts")
                                    }
                                </span>
                            )
                        }
                         
                </PostBtn> 
                {isDropped && (
                    <PostSelectUl>
                        {!isViewingAll && (
                            <li className='postItemSelectLi' onClick={() => handleClick('all')} value="all">
                                <div>
                                    <IoMdRefreshCircle className='postTypeIcons' />
                                    {translate("web:general.Show All")}
                                </div>
                            </li>
                        )}
                        <li className='postItemSelectLi' onClick={() => handleClick('Prayer Request')} value="Prayer Request">
                            <div>
                                <FaPersonPraying    className='postTypeIcons' />
                                {translate("web:general.Prayers")}
                            </div>
                        </li>
                        <li className='postItemSelectLi' onClick={() => handleClick('Praise')}>
                            <div>
                                <BsPersonRaisedHand className='postTypeIcons' />
                                {translate("web:general.Praises")}
                            </div>
                        </li>
                        <li className='postItemSelectLi' onClick={() => handleClick('Testimony')}>
                            <div>
                                <FaPersonWalking className='postTypeIcons' />
                                {translate("web:general.Testimonies")}
                            </div>
                        </li>        
                    </PostSelectUl>  
                )}

        </div>
    )
}

export default PostItemFilter
